/**
 * @file Automatically generated by barrelsby.
 */

export * from './icon-toggle-group.component';
